import { Route } from '@angular/router';

export const investorChannelingRoutes: Route = {
  path: 'investor-chan',
  data: { title: 'Channeling' },
  loadChildren: () =>
    import('../modules/investor-chan/investor-chan.module').then((m) => m.InvestorChannelingModule),
};
